import React, { useEffect, useState } from 'react';
import { Provider } from 'mobx-react';
import { useNavigate } from 'react-router-dom';

import { ThemeProvider } from '@availity/element';

import Layout from './Common/layout/index';

import ApplicationDown from './Common/components/ApplicationDown/ApplicationDown';

import commonStore from './Common/stores/CommonStore';
import messageStore from './Common/stores/MessageStore';
import providerStore from './Common/stores/ProviderStore';
import incidentStore from './Common/stores/IncidentStore';

const App = () => {
  const [renderPage, setRenderPage] = useState(false);
  const [showLayout, setShowLayout] = useState(false);

  const navigate = useNavigate();
  const perfEntries = performance.getEntriesByType('navigation');
  const p = perfEntries[0];
  const isPageReloaded = p.type === 'reload';

  useEffect(() => {
    async function startUpFn() {
      messageStore.disableMessage();
      commonStore.blocking = true;
      const { hostname, search } = window.location;
      const urlParams = new URLSearchParams(search);
      const isAvailityDomain = hostname.endsWith('.availity.com') || urlParams.has('spaceId');

      // Document-related changes should always run
      if (isAvailityDomain) {
        const favicon = document.querySelector('link[rel="icon"]');
        if (favicon) {
          document.head.removeChild(favicon);
        }
      } else {
        document.title = 'Incident Form Application';
      }

      try {
        const configResult = await commonStore.callPrvprtlConfigApiForAppConfig();
        if (!configResult) {
          setShowLayout(false);
          throw new Error('No config');
        }

        if (isAvailityDomain) {
          const isPayerDetailsObtained = await commonStore.getSpacesApi();
          if (!isPayerDetailsObtained) throw new Error('Payer details fetch failed');

          const isUserDetailsFetched = await commonStore.getUser();
          if (!isUserDetailsFetched) throw new Error('User fetch failed');

          const isRegionDetailsObtained = await commonStore.getCurrentRegion();
          if (!isRegionDetailsObtained) throw new Error('Region fetch failed');

          await commonStore.getTemplate();

          const isTermsOfUseObtained = await commonStore.getTermsOfUse();
          if (!isTermsOfUseObtained) throw new Error('Terms fetch failed');
        } else {
          commonStore.setupPublicFacingFlow();
        }

        setShowLayout(true);
      } catch {
        window.scrollTo(0, 0);
        setShowLayout(false);
      } finally {
        setRenderPage(true);
        commonStore.blocking = false;
      }
    }

    startUpFn();
  }, []);

  useEffect(() => {
    messageStore.disableMessage();
    commonStore.blocking = false;
    navigate('/', { replace: true });
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [isPageReloaded]);

  return (
    <ThemeProvider>
      {renderPage ? (
        showLayout ? (
          <Provider
            commonStore={commonStore}
            messageStore={messageStore}
            providerStore={providerStore}
            incidentStore={incidentStore}
          >
            <Layout />
          </Provider>
        ) : (
          <ApplicationDown />
        )
      ) : null}
    </ThemeProvider>
  );
};

export default App;
